import * as React from "react";

interface AddCommentIconProps {
  id?: string;
  fill?: string;
  className?: string;
}

export const AddCommentIcon: React.SFC<AddCommentIconProps> = ({
  id = 0,
  fill = "#747474",
  className
}) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <title>Icon/Add Comment</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <path
        d="M20,2 C20,0.9 19.1,0 18,0 L2,0 C0.9,0 0,0.9 0,2 L0,14 C0,15.1 0.9,16 2,16 L16,16 L20,20 L20,2 Z M18,15.17 L16.83,14 L2,14 L2,2 L18,2 L18,15.17 Z M11,3 L9,3 L9,7 L5,7 L5,9 L9,9 L9,13 L11,13 L11,9 L15,9 L15,7 L11,7 L11,3 Z"
        id={`path-add-comment-${id}`}
      />
    </defs>
    <g
      id={`Symbols-${id}`}
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id={`Icon/Add-Comment-${id}`}
        transform="translate(-2.000000, -2.000000)"
      >
        <g>
          <polygon id={`Path-${id}`} points="0 0 24 0 24 24 0 24" />
          <g id={`icon-color-${id}`} transform="translate(2.000000, 2.000000)">
            <mask id={`mask-add-comment-${id}`} fill="white">
              <use href={`#path-add-comment-${id}`} />
            </mask>
            <use
              id={`Mask-${id}`}
              fill={fill}
              fillRule="nonzero"
              href={`#path-add-comment-${id}`}
            />
            <g
              id={`Color-/-Dark-Gray-${id}`}
              mask={`url(#mask-add-comment-${id})`}
              fill={fill}
            >
              <g
                transform="translate(-2.000000, -2.000000)"
                id={`Rectangle-2-${id}`}
              >
                <rect x="0" y="0" width="24" height="24" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/commentView/AddCommentIcon.tsx